{
  "version": 1,
  "asset_id": "d3e43c5f-05bc-4778-a95a-6a08ef8bacc4",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/d3e43c5f-05bc-4778-a95a-6a08ef8bacc4/clip-img_1994.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/d3e43c5f-05bc-4778-a95a-6a08ef8bacc4/clip-img_1994.mp4",
  "original_filename": "clip-img_1994.mp4",
  "size": 276248,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:33Z"
}
